import { heFetch } from './HeFetch';
import getTrackingPageName from './tracking-page-name.config';
import i18n from '../i18n';
import SavedSearchesModel from '../models/Alert';

export const fetchUserSavedSearches = async (userId) => {
    const baseHeaders = {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language
    };

    try {
        const response = await heFetch.get(
            `/search/saved-searches?userId=${userId}&limit=100&excludeSource=onboarding`,
            {
                headers: {
                    ...baseHeaders,
                    'X-HE-PAGE-NAME': getTrackingPageName(window?.location?.pathname)
                }
            }
        );

        return response.data.map((search) => {
            const alertData = {
                id: search.externalId,
                externalId: search.externalId,
                searchCriteria: search.searchCriteria || {},
                displayInformation: search.displayInformation || {},
                alertConfig: search.alertConfig || {},
                queryParams: search.queryParams || '',
                place: search.displayInformation?.title || '',
                description: search.displayInformation?.description,
                status: search.alertConfig?.enabled
                    ? SavedSearchesModel.STATUS_ENABLED
                    : SavedSearchesModel.STATUS_DISABLED,
                created_at: search.createdAt,
                userId: userId,
                is_onboarding: search.source === 'onboarding'
            };
            return new SavedSearchesModel(alertData);
        });
    } catch (error) {
        console.error('Error fetching user saved searches:', error);
        return [];
    }
};
